import React from 'react';
import { Box, Typography } from '@mui/material';
import { Activity } from 'lucide-react';
import PlatformStateSection from '../../features/qCockpit/sections/PlatformStateSection';

export default function PHealth() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Activity size={20} />
                <Box>
                    <Typography sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
                        pHealth
                    </Typography>
                    <Typography sx={{ fontSize: '0.8rem', opacity: 0.7 }}>
                        Platform health · always-on telemetry across all strategies and modes
                    </Typography>
                </Box>
            </Box>
            <PlatformStateSection />
        </Box>
    );
}
